import React, { Component } from 'react';
import PropTypes from 'prop-types';
import logo from './logo.svg';
import './Loading.css';

class Loading extends Component {
  static propTypes = {
    hide: PropTypes.bool,
  };

  static defaultProps = {
    hide: false,
  }

  render() {
    const { hide } = this.props;
    const componentClasses = ['animated'];
    if (hide) {
      componentClasses.push('fadeOut');
    }

    return (
      <div className="loadingContainer">
        <div className={componentClasses.join(' ')}>
          <img src={logo} alt="logo" width="260" />
        </div>
      </div>
    );
  }
}

export default Loading;



// WEBPACK FOOTER //
// ./src/components/loading/Loading.js